<template>
    <v-form-control :field="field" :class="classes">
        <template scope="api">
            <v-radio :readonly="api.isReadonly() || readonly" :disabled="disabled" :value="api.getValue()"
            :clickEvent="clickEvent" @input="api.setValue" @blur="api.setTouched" :data="data" :caption="caption" :label="label" :error="api.getTouched() ? api.getError() : undefined" />
        </template>
    </v-form-control>
</template>
<script>
    import theme from './theme.scss';

    export default {
        name: 'form-radio',
        props: {
            data: [String, Number, Boolean, Object],
            label: String,
            caption: String,
            error: String,
            clickEvent: Function,
            field: {
                type: String,
                required: true,
            },
            readonly: Boolean,
            inline: Boolean,
            disabled: Boolean,
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        computed: {
            classes() {
                return {
                    [this.theme.inline]: this.inline,
                };
            }
        }
    }
</script>


// WEBPACK FOOTER //
// FormRadio.vue?6ef41cb4